import { render, staticRenderFns } from "./bonusManage.vue?vue&type=template&id=0fa80f6c&"
import script from "./bonusManage.vue?vue&type=script&lang=js&"
export * from "./bonusManage.vue?vue&type=script&lang=js&"
import style0 from "./bonusManage.vue?vue&type=style&index=0&id=0fa80f6c&prod&lang=less&"
import style1 from "./bonusManage.vue?vue&type=style&index=1&id=0fa80f6c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports